import {
  Mail, BarChart2, TrendingUp, TrendingDown,
  Target, ShieldCheck, Users, MapPin, GraduationCap,
  ArrowUpFromLine, Coins, Radar, Activity, Wallet, RefreshCw,
  BookOpen,
} from 'lucide-react';
import type { DriverMetadata } from './types';

/**
 * Metadata locale dei driver Conduct Risk, indicizzata per `kind`.
 * Ogni source ha label leggibile + document_type BE (quando applicabile)
 * per rendere il badge cliccabile → download del file.
 */
export const DRIVER_METADATA: Record<string, DriverMetadata> = {
  Driver01: {
    description: 'KPI sul tempo medio di lavorazione e percentuale reclami evasi oltre i termini normativi.',
    sources:     [
      { label: 'Riepilogo Performance (email)', docType: 'performance_summary_email' },
    ],
    icon:        Mail,
  },
  Driver02: {
    description: 'Riepilogo del Premio di Eccellenza Quota A e Quota B per Direzione Regionale e nazionale.',
    sources:     [
      { label: 'PVR Quota A',          docType: 'pvr_quota_a' },
      { label: 'PVR Quota Opzionale',  docType: 'pvr_quota_optional' },
    ],
    icon:        BarChart2,
  },
  Driver03: {
    description: 'Analisi dei ricavi lordi, raggiungimento budget e confronto biennale per segmenti commerciali.',
    sources:     [
      { label: 'MINTR corrente',   docType: 'mintr_current' },
      { label: 'MINTR precedente', docType: 'mintr_prior' },
      { label: 'PVR Quota A',      docType: 'pvr_quota_a' },
    ],
    icon:        TrendingUp,
  },
  Driver04: {
    description: 'Identificazione delle filiali con picchi di ricavi nel IV trimestre rispetto alla media annuale.',
    sources:     [
      { label: 'Evoluzione Ricavi', docType: 'evoluzione_ricavi' },
      { label: 'PVR Quota A',       docType: 'pvr_quota_a' },
    ],
    icon:        TrendingDown,
  },
  Driver05: {
    description: 'Punteggio complessivo eccellenza, dettaglio indicatori NPS, credito, servizio e operativa.',
    sources:     [
      { label: 'PVR Quota A',     docType: 'pvr_quota_a' },
      { label: 'ESTRATTO SEI OK', docType: 'sei_ok' },
    ],
    icon:        Target,
  },
  Driver06: {
    description: 'Correlazione tra filiali a premio e ICF a rischio medio/alto per ambito normativo.',
    sources:     [
      { label: 'PVR Quota A', docType: 'pvr_quota_a' },
      { label: 'ICF',         docType: 'icf' },
    ],
    icon:        ShieldCheck,
  },
  Driver07: {
    description: 'Analisi dei Global Advisor con e senza premio variabile di rendimento per Direzione Regionale.',
    sources:     [
      { label: 'PVR Quota A',    docType: 'pvr_quota_a' },
      { label: 'Global Advisor', docType: 'global_advisor' },
    ],
    icon:        Users,
  },
  Driver08: {
    description: 'Punteggio MAP direttori d\'area, eccellenza operativa e peso filiali non a premio.',
    sources:     [
      { label: 'PVR Quota A',                        docType: 'pvr_quota_a' },
      { label: 'Risultati Direttori d\'Area',         docType: 'risultati_direttori_area' },
      { label: 'Dettaglio Scheda Direttori d\'Area',  docType: 'dettaglio_scheda_direttori_area' },
    ],
    icon:        MapPin,
  },
  Driver09: {
    description: 'Dipendenti con mancata fruizione o ritardo nella fruizione della formazione obbligatoria.',
    sources:     [
      { label: 'Riepilogo Performance (email)', docType: 'performance_summary_email' },
    ],
    icon:        GraduationCap,
  },
  // ─── Investigation drivers (analisi manuali Compliance) ──────────────
  Driver10: {
    description: 'Filiali che effettuano un doppio, triplo o quadruplo salto di fascia tra Q3 e Q4.',
    sources:     [
      { label: 'PVR Quota A Q3', docType: 'pvr_quota_a_september' },
      { label: 'PVR Quota A', docType: 'pvr_quota_a' },
    ],
    icon:        ArrowUpFromLine,
  },
  Driver11: {
    description: 'Filiali con incrementi sostanziali delle commissioni nette Quota C nell\'ultimo trimestre.',
    sources:     [
      { label: 'PVR Quota C Q3', docType: 'pvr_quota_c_september' },
      { label: 'PVR Quota Opz. Q4', docType: 'pvr_quota_optional' },
    ],
    icon:        Coins,
  },
  Driver12: {
    description: 'Identificazione filiali outlier con clustering sul raggiungimento del budget ricavi.',
    sources:     [
      { label: 'PVR Quota A', docType: 'pvr_quota_a' },
    ],
    icon:        Radar,
  },
  Driver13: {
    description: 'Estensione dell\'analisi picchi ricavi ai trimestri Q1/Q2/Q3 e al mese di dicembre.',
    sources:     [
      { label: 'Evoluzione Ricavi', docType: 'evoluzione_ricavi' },
      { label: 'PVR Quota A',       docType: 'pvr_quota_a' },
    ],
    icon:        Activity,
  },
  Driver14: {
    description: 'Filiali/Global Advisor con incremento sostanziale del flusso netto risparmio gestito a dicembre.',
    sources:     [
      { label: 'Global Advisor', docType: 'global_advisor' },
      { label: 'PVR Quota A',    docType: 'pvr_quota_a' },
    ],
    icon:        Wallet,
  },
  Driver15: {
    description: 'Global Advisor con decremento FNPC a dicembre e successivo incremento a gennaio.',
    sources:     [
      { label: 'Global Advisor', docType: 'global_advisor' },
      { label: 'PVR Quota A',    docType: 'pvr_quota_a' },
    ],
    icon:        RefreshCw,
  },
  // ─── Annex (allegati di sola consultazione) ─────────────────────────
  Annex52: {
    description: 'Allegato 5.2 al Sistema Incentivante — regole PVR di riferimento.',
    sources:     [
      { label: 'Annex PVR', docType: 'regole_pvr' },
    ],
    icon:        BookOpen,
  },
};
